import Navbar from "../../components/Navbar";
import {Box, useMediaQuery} from "@mui/material";
import {Outlet} from "react-router-dom";
import Sidebar from "../../components/Sidebar";
import {useState} from "react";

const Layout = () => {

    const isNonMobile = useMediaQuery("(min-width: 600px)");
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    return (
        <Box display={isNonMobile ? "flex" : "block"} width="100%" height="100%">
            <Sidebar
                isNonMobile={isNonMobile}
                drawerWidth="250px"
                isSidebarOpen={isSidebarOpen}
                setIsSidebarOpen={setIsSidebarOpen}
            />
            <Box flexGrow={1}>
                <Navbar
                    isSidebarOpen={isSidebarOpen}
                    setIsSidebarOpen={setIsSidebarOpen}/>
                <Outlet/>
            </Box>
        </Box>
    )
}

export default Layout